import type { UrlTree } from '@angular/router';
import type { BadgeColor } from '@h20-shared/generic-badge/generic-badge.component';

export type KpiCardBadge = { readonly label: string; readonly color: BadgeColor };

export const KPI_CARD_STATUSES = ['neutral', 'positive', 'attention', 'critical'] as const;
export type KpiCardStatus = (typeof KPI_CARD_STATUSES)[number];

export type KpiCardValueSuffix = { readonly word: string; readonly value: string };

/**
 * A link under the value.
 * Without `routerLink` it renders as plain disabled text, for previews that have no destination.
 */
export type KpiCardLink = {
    readonly label: string;
    readonly routerLink?: UrlTree;
};

export type KpiCardGridDirection = 'row' | 'column';

/** How much the card's main value stands out */
export const KPI_CARD_VALUE_EMPHASES = ['standard', 'large', 'extra large'] as const;
export type KpiCardValueEmphasis = (typeof KPI_CARD_VALUE_EMPHASES)[number];

/** Which side the value, the second number and the caption sit on */
export const KPI_CARD_ALIGNMENTS = ['left', 'center', 'right'] as const;
export type KpiCardAlignment = (typeof KPI_CARD_ALIGNMENTS)[number];

/** How much the card's label stands out */
export const KPI_CARD_LABEL_EMPHASES = ['default', 'emphasized'] as const;
export type KpiCardLabelEmphasis = (typeof KPI_CARD_LABEL_EMPHASES)[number];
